import { useMemo } from 'react'

import { dummyLearningItem } from '../../models/LearningItem'
import useUserLearningItems from './useUserLearningItems'

export default function useUserLearningItem(userUuid: string, learningItemUuid: string) {
  const { userLearningItems, error, isPlaceholderData } = useUserLearningItems(userUuid)
  const userLearningItem = useMemo(() => {
    const item = userLearningItems.find(({ uuid }) => uuid === learningItemUuid)
    if (!item) {
      if (error) {
        return dummyLearningItem(learningItemUuid, error)
      } else if (isPlaceholderData) {
        return dummyLearningItem(learningItemUuid)
      }
      return dummyLearningItem(learningItemUuid, new Error('Learning item not found'))
    }

    return item
  }, [userLearningItems, error, isPlaceholderData, learningItemUuid])
  return { userLearningItem }
}
